import { render, staticRenderFns } from "./GPathCareerUnivScholarshipList.vue?vue&type=template&id=b9ad99ee"
import script from "./GPathCareerUnivScholarshipList.vue?vue&type=script&lang=js"
export * from "./GPathCareerUnivScholarshipList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports